// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationContentBlocksPage_wrapper__1iYHo"};